import I18n from 'I18n';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import ChangePlaylistThumbnailButton from './ChangePlaylistThumbnailButton';
import PlaylistItemsSearch from './PlaylistItemsSearch';
import { CardMenuOptions } from '../../cardMenu/components/CardMenu';
import { jsx as _jsx } from "react/jsx-runtime";
const PLAYLIST_ITEMS_HEIGHT = 250;
const ChangeThumbnailItemsList = ({
  playlist: {
    id: playlistId
  },
  items,
  renderList = content => /*#__PURE__*/_jsx(ScrollContainer, {
    maxHeight: PLAYLIST_ITEMS_HEIGHT,
    children: /*#__PURE__*/_jsx(CardMenuOptions, {
      "aria-label": I18n.text('learningCenter.cardMenu.playlistItems'),
      children: content
    })
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(SideNavItem, {
    title: content
  }, key),
  onItemClick
}) => {
  return renderList(items && items.map(item => {
    const {
      itemId
    } = item;
    return renderRow( /*#__PURE__*/_jsx(ChangePlaylistThumbnailButton, {
      block: true,
      item: item,
      onClick: () => {
        if (onItemClick) onItemClick(item);
      },
      playlistId: playlistId
    }), `playlist_${playlistId}_item_${itemId}`);
  }));
};
const ChangePlaylistThumbnail = ({
  playlistId,
  renderList,
  renderRow,
  onItemClick
}) => {
  return /*#__PURE__*/_jsx(PlaylistItemsSearch, {
    playlistId: playlistId,
    render: (playlist, items) => playlist && items && /*#__PURE__*/_jsx(ChangeThumbnailItemsList, {
      items: items,
      onItemClick: onItemClick,
      playlist: playlist,
      renderList: renderList,
      renderRow: renderRow
    })
  });
};
export default ChangePlaylistThumbnail;